const shuffle = (list) => {
  const copy = [...list]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
      ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy
}

// A derangement: nobody can draw their own name. Retrying a full shuffle
// until none matches is simple and plenty fast for typical group sizes.
export const generateSecretSantaPairs = (names) => {
  if (names.length < 3) return null
  let receivers
  let attempts = 0
  do {
    receivers = shuffle(names)
    attempts += 1
  } while (
    receivers.some((name, i) => name === names[i]) &&
    attempts < 200
  )
  if (receivers.some((name, i) => name === names[i])) return null

  return names.map((name, i) => ({ from: name, to: receivers[i] }))
}
